import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";
import {Link} from "react-router-dom";

const useStyles = makeStyles({
  root: {
    minWidth: 275,
  },
  bullet: {
    display: "inline-block",
    margin: "0 2px",
    transform: "scale(0.8)",
  },
  title: {
    fontSize: 14,
  },
  pos: {
    marginBottom: 12,
  },
});

function PatientCard(props) {
  return (
    <Card className="card">
      <CardContent>
        <Typography
        style={{textDecoration: 'none'}}
          component={Link}
          to={`/users/${props.patient.patientId}`}
        >
          <h1 style={{backgroundColor:'#3f51b5', color:'white',borderRadius: 8}}>{props.patient.name}</h1>
        </Typography>
        <Typography
          //   className={classes.title}
          color="textSecondary"
          gutterBottom
        >
          {props.patient.email}
        </Typography>

        <Typography
          //   className={classes.title}
          color="textSecondary"
          gutterBottom
        >
          {props.patient.notify === true && <h2>New message!</h2>}
        </Typography>
      </CardContent>
    </Card>
  );
}

export default PatientCard;
